import React from 'react'
import './Home.css'
import BannerTerms from './BannerTerms'
import Terms from './Terms'

function TermsPage() {
    return (
        <div className='home'>
            <BannerTerms />
            <Terms />
        </div>
    )
}

export default TermsPage